// API Configuration
const config = {
    API_BASE_URL: process.env.REACT_APP_API_URL || 'https://api.trioperspective.com',
};

export default config;
